import { useState } from "react";
import { useLanguageContext } from "../../../Languages/Langs/LanguageContext";
import { ModelWindow } from "../../../ModelWindow/ModelWindow";
import {
  AboutUsContainer,
  AboutUsList,
  AboutUsListCardTitle,
  AboutUsListItem,
  AboutUsPictureEasy,
  AboutUsPictureLangs,
  AboutUsPictureSecure,
  AboutUsSection,
  AboutUsTitle,
  DescribeButton,
  DescribeContainer,
  DescribeText,
} from "./AboutUs.styled";
import { SignUpModel } from "../Header/SignUpModel/SignUpModel";

export const AboutUs = () => {
  const { t } = useLanguageContext();
  const [showSignUp, setShowSignUp] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  const openSignUp = () => {
    setShowSignUp(true);
    setTimeout(() => setIsSignUpOpen(true), 0);
  };

  const closeSignUp = () => {
    setIsSignUpOpen(false);
    setTimeout(() => setShowSignUp(false), 250);
  };

  return (
    <>
      <AboutUsSection>
        <AboutUsTitle>{t("publicTranslate.aboutUsTitle")}</AboutUsTitle>
        <AboutUsContainer>
          <AboutUsList>
            <AboutUsListItem>
              <AboutUsListCardTitle>
                {t("publicTranslate.aboutUsTitleSecure")}
              </AboutUsListCardTitle>
              <AboutUsPictureSecure />
            </AboutUsListItem>
            <AboutUsListItem>
              <AboutUsListCardTitle>
                {t("publicTranslate.aboutUsEasyToUse")}
              </AboutUsListCardTitle>
              <AboutUsPictureEasy />
            </AboutUsListItem>
            <AboutUsListItem>
              <AboutUsListCardTitle>
                {t("publicTranslate.aboutUsLangs")}
              </AboutUsListCardTitle>
              <AboutUsPictureLangs />
            </AboutUsListItem>
          </AboutUsList>
        </AboutUsContainer>
        <DescribeContainer>
          <DescribeText>{t("publicTranslate.DescibeTextApp")}</DescribeText>
          <DescribeButton type="button" onClick={openSignUp}>
            {t("publicTranslate.getStartedButtonText")}
          </DescribeButton>
        </DescribeContainer>
      </AboutUsSection>

      {showSignUp && (
        <ModelWindow onClose={closeSignUp} isOpen={isSignUpOpen}>
          <SignUpModel onClose={closeSignUp} />
        </ModelWindow>
      )}
    </>
  );
};
